import Image from "next/image";

export function Logo({
  iconOnly = false,
  white = false,
}: {
  iconOnly?: boolean;
  white?: boolean;
}) {
  if (iconOnly) {
    return (
      <Image
        src="/img/infoplaza-icon.png"
        alt="Icon"
        width={512}
        height={512}
        priority
        className="h-5 w-auto"
      />
    );
  }

  return (
    <Image
      src={white ? "/img/infoplaza-logo-white.svg" : "/img/infoplaza-logo.svg"}
      alt="Logo"
      width={180}
      height={46}
      priority
      className="h-8 w-auto"
    />
  );
}
